export const getArray = (element) =>
  typeof element === "string" ? JSON.parse(element) : element;
